module.exports = __webpack_public_path__ + "static/media/login-img-tablet.1706791b.png";